
export enum ModalActionTypes {
    TERMS_AND_CONDITIONS_MODAL_OPEN = "TERMS_AND_CONDITIONS_MODAL_OPEN",
    TERMS_AND_CONDITIONS_MODAL_CLOSE = "TERMS_AND_CONDITIONS_MODAL_CLOSE"
}

export type ModalAction =
    | ReturnType<typeof openTermsAndConditionsModal>
    | ReturnType<typeof closeTermsAndConditionsModal>;

export function openTermsAndConditionsModal(content: string, modalTitle: string) {
    return {
        type: ModalActionTypes.TERMS_AND_CONDITIONS_MODAL_OPEN,
        content,
        modalTitle
    } as const;
}

export function closeTermsAndConditionsModal() {
    return {
        type: ModalActionTypes.TERMS_AND_CONDITIONS_MODAL_CLOSE,
    } as const;
}